import { useEffect } from 'react'
import { HelmetProvider } from 'react-helmet-async'
import { Provider } from 'react-redux'
import { RouterProvider } from 'react-router-dom'
import { Close as CloseIcon } from '@mui/icons-material'
import { IconButton } from '@mui/material'
import { SnackbarProvider, useSnackbar } from 'notistack'
import gitInfo from '~root/git-info.json'
import './locales'
import { router } from './routes'
import store from './store'
import '~/styles/app.css'
import '~/styles/sass/app.scss'

interface SnackbarCloseButtonProps {
  snackbarKey?: number | string
}

const SnackbarCloseButton = ({ snackbarKey }: SnackbarCloseButtonProps) => {
  const { closeSnackbar } = useSnackbar()

  return (
    <IconButton
      sx={{ color: 'inherit' }}
      aria-label="close"
      size="small"
      onClick={() => closeSnackbar(snackbarKey)}
    >
      <CloseIcon sx={{ width: '0.75em' }} />
    </IconButton>
  )
}

export default function App() {
  useEffect(() => {
    const app = document.getElementById('app')
    if (app) {
      app.setAttribute('data-commit-hash', gitInfo.commitHash)
    }
  }, [])

  return (
    <SnackbarProvider
      anchorOrigin={{
        horizontal: 'right',
        vertical: 'bottom',
      }}
      autoHideDuration={5000}
      action={(snackbarKey) => (
        <SnackbarCloseButton snackbarKey={snackbarKey} />
      )}
      preventDuplicate
    >
      <HelmetProvider>
        <Provider store={store}>
          <RouterProvider router={router} />
        </Provider>
      </HelmetProvider>
    </SnackbarProvider>
  )
}
